/**
 * Operator-facing byte formatting, in the dependency-free package so BOTH the
 * worker (alarm email/body) and the browser (the Operations disk panel) render
 * one disk the same way.
 *
 * It lived in `features/files/core/storage.ts`, which imports `node:fs` at
 * module load — so the browser panel could not import it and had reimplemented
 * it, drifting to a different unit suffix. The NUMBER is the thing that must
 * never diverge between the two surfaces (an operator compares "6.9" on the
 * panel to "6.9" in the page); moving the pure formatter here makes that
 * structural rather than a comment. `storage.ts` now re-exports `formatGib`, so
 * every existing worker import is unchanged.
 */

/** One-decimal GiB with the terse `G` suffix — what the alarm subject and body
 *  quote (brevity matters in an SMS-length page). */
export function formatGib(bytes: number): string {
  return `${(bytes / (1024 ** 3)).toFixed(1)}G`
}

/** The SAME number, with a more readable ` GiB` suffix for a UI panel. Derived
 *  from `formatGib` rather than re-dividing, so the figure can never drift from
 *  the one the email quotes — only the unit label differs. */
export function formatGibReadable(bytes: number): string {
  return formatGib(bytes).replace(/G$/, ' GiB')
}
